const adminCoulmns = [
  'priority',
  'operation',
  'service',
  'uniqueCustomerTransactionId',
  'uniqueProviderTransactionId',
  'responseStatus',
  'customerCode',
  'providerCode',
  'providerCustomerCode',
  'aggregatorCode',
  'targetOperation',
  'targetService',
  'timeTaken',
  'requestType',
  'createdTime',
  'statusCode',
  'responseHttpStatus',
  'retryCount',
  'retryStatus'
];

const providerColumns = ['service', 'providerCode'];
const customerColumns = ['service', 'customerCode'];
const aggregatorColumns = ['service', 'aggregatorCode'];
const archiveColumn = ['responseStatus', 'requestType'];

const freightTrackingColumn = [
  'priority',
  'id',
  'lmd',
  'shipmentId',
  'ingestionId',
  'shipmentMode',
  'partnerName',
  'carrierName',
  'plannedShipDate',
  'plannedDeliveryDate',
  'stops',
  'loadStatus'
];

const outboundNotificationColumns = [
  'uniqueCustomerTransactionId',
  'uniqueProviderTransactionId',
  'requestType',
  'customerCode',
  'providerCode',
  'timeTaken',
  'initialHttpStatus',
  'responseHttpStatus',
  'retryCount',
  'createdTime',
  'retryStatus'
];

const customerAccessColumns = [
  'operation',
  'uniqueCustomerTransactionId',
  'targetService',
  'targetOperation',
  'responseStatus',
  'customerCode',
  'providerCode',
  'timeTaken',
  'initialHttpStatus',
  'responseHttpStatus',
  'retryCount',
  'createdTime',
  'retryStatus'
];
const carrierCollaborationColumns = ['targetOperation', 'targetService'];
const dynamicCapacityColumns = ['targetOperation', 'targetService'];

const customTitles: any = {
  freightTracking: {
    uniqueCustomerTransactionId: 'Shipment Id',
    uniqueProviderTransactionId: 'Load Number',
    responseStatus: 'Ingestion ID'
  },
  outboundNotification: {
    uniqueCustomerTransactionId: 'Entity ID',
    requestType: 'Event Type',
    uniqueProviderTransactionId: 'File Name'
  },
  customerAccess: {
    uniqueCustomerTransactionId: 'Entity ID',
    targetService: 'Network Service',
    targetOperation: 'Transaction Type'
  }
};

export {
  adminCoulmns,
  providerColumns,
  customerColumns,
  aggregatorColumns,
  customerAccessColumns,
  customTitles,
  freightTrackingColumn,
  carrierCollaborationColumns,
  dynamicCapacityColumns,
  outboundNotificationColumns,
  archiveColumn
};
